import React, { FC } from 'react'

import { FormControlLabel, Radio, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useThemeMode } from '../../theme/ThemeModeContext'

import { Psychology, RadioButtonProps, RadioButtonColors } from './types'

const getMainColor = (label: string, colors: RadioButtonColors) => {
  switch (label) {
    case Psychology.positive:
      return colors.green
    case Psychology.negative:
      return colors.red
    default:
      return colors.grey || ''
  }
}

export const RadioButton: FC<RadioButtonProps> = ({ label, checked, width }) => {
  const { spacing, palette } = useTheme()
  const { resolvedMode } = useThemeMode()

  const { t } = useTranslation()
  const labelText = t(`tradingLogPage.journaling.answers.${label}`, t(label, label))
  const mainColor = getMainColor(label, { green: palette.green[400], red: palette.red[400] })
  const backgroundColor = getMainColor(label, {
    green: resolvedMode === 'dark' ? '#129b67ff' : palette.green[100],
    red: resolvedMode === 'dark' ? '#b80a0aff' : palette.red[100],
    grey: palette.primary.main,
  })

  return (
    <FormControlLabel
      value={label}
      checked={checked}
      control={<Radio sx={{ display: 'none' }} />}
      label={labelText}
      sx={{
        height: spacing(5.5),
        width: spacing(width || 20.5),
        m: 0,
        border: `1px solid ${palette.grey[500]}`,
        borderRadius: spacing(2.75),
        '& .MuiFormControlLabel-label': {
          width: '100%',
          color: mainColor,
          fontWeight: 500,
          lineHeight: spacing(2.75),
          textAlign: 'center',
          textTransform: 'capitalize',
          ...(Boolean(checked && resolvedMode === 'dark') && {
            color: '#FFFFFF',
          }),
        },
        ...(checked && {
          borderColor: resolvedMode === 'dark' ? 'transparent' : mainColor,
          backgroundColor: backgroundColor,
        }),
        '&:hover': {
          borderColor: palette.grey[700],
        },
      }}
    />
  )
}
